import Flickity from 'flickity';

export default class Slider {

    constructor(el, viewport){
        this.slider = el;
		if(this.slider && el.classList.contains('mobile-slider') && viewport < 768) {
			this.sliderInit(this.slider);
		} else if(this.slider && !el.classList.contains('mobile-slider')) {
			this.sliderInit(this.slider);
		}
    }

    sliderInit(data){
		let spas = data.getAttribute('data-slider');
        let flkty = new Flickity( data, {
            pageDots: false,
            prevNextButtons: false,
            contain: true,
            wrapAround: true,
            imagesLoaded: true,
			cellAlign: 'left'
        });
    }

}